import React from 'react';
import { Button } from 'antd';
import { useSelector } from 'react-redux';

import { safeExtractFromObject } from '../../helpers/helpers';

const getButtonStyle = (style = {}, fat = false) => ({
  borderRadius:20,
  width:120,
  height:fat ? 42 : 40,
  borderWidth:1.5,
  ...style,
});

const OnTraccrButton = ({
  id,
  onClick,
  title,
  icon,
  type = 'primary',
  disabled = false,
  style = {},
  iconLeft = false,
  href,
  titleStyle = {},
  roundStyle = false,
  fat = false,
  onMouseEnter,
  onMouseLeave,
  onFocus,
  htmlType,
  className = '',
  titleClassName = '',
  loading,
  isRedesign = false,
  testId,
}) => {
  const settings = useSelector((state) => safeExtractFromObject(state, 'settings.company.settings'));
  const hasRedesign = isRedesign || settings?.uxRedesignPt1;
  const classSuffix = hasRedesign ? 'button-redesign' : '';
  return (
    <Button
      id={id}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onFocus={onFocus}
      className={`OnTraccrBtn-${type} ${classSuffix} ${className}`}
      type='primary'
      style={roundStyle ? getButtonStyle(style,fat) : {...style, }}
      onClick={onClick}
      disabled={disabled}
      href={href}
      htmlType={htmlType}
      loading={loading}
      data-testid={testId}
    >
      {iconLeft ? icon : ''}
      {title && <span style={titleStyle} className={titleClassName}>{title}</span>}
      {iconLeft ? '' : icon}
    </Button>
  )
}

export default OnTraccrButton;
